export default __webpack_public_path__ + "static/card-3-2cbd3ceb34c23cb6b9c6ee94769c2190.png";